module.exports = __webpack_public_path__ + "static/media/map-marker-solid.4f89186c.svg";